var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { useLanguage } from '@base/LanguageProvider';
import { useFinancialYearUpdate } from '@data/hooks/settings';
import Manager from '@shared/modal/Manager';
import Modal from '@shared/modal/Modal';
import ModalHeader from '@shared/modal/ModalHeader';
import ModalFooter from '@shared/modal/ModalFooter';
import SelectInput from '@shared/input/SelectInput';
// styled components:
import { ModalBody } from '@styled/Modal';
function YearsSetupModal() {
    return (React.createElement(Modal, { width: 400 },
        React.createElement(YearsSetupModalForm, null)));
}
var YearsSetupModalForm = function () {
    var L = useLanguage().L;
    var _a = useFinancialYearUpdate(), updateFinancialYear = _a.mutate, data = _a.data, error = _a.error, isError = _a.isError, isLoading = _a.isLoading, isSuccess = _a.isSuccess;
    var _b = __read(useState(data.value), 2), financialYearStartingMonth = _b[0], setFiscalYearStartMonth = _b[1];
    var done = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (financialYearStartingMonth !== data.value) {
                updateFinancialYear(__assign(__assign({}, data), { value: financialYearStartingMonth }));
            }
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        if (isSuccess) {
            Manager.closeModal();
        }
    }, [isSuccess]);
    var handleChange = function (e) {
        setFiscalYearStartMonth(e.target.value);
    };
    var monthOptions = [
        { label: 'January', value: '1' },
        { label: 'Febuary', value: '2' },
        { label: 'March', value: '3' },
        { label: 'April', value: '4' },
        { label: 'May', value: '5' },
        { label: 'June', value: '6' },
        { label: 'July', value: '7' },
        { label: 'August', value: '8' },
        { label: 'September', value: '9' },
        { label: 'October', value: '10' },
        { label: 'November', value: '11' },
        { label: 'December', value: '12' },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { title: L('Years settings') }),
        React.createElement(ModalBody, null,
            React.createElement("form", null,
                React.createElement(SelectInput, { name: "financialYearStartingMonth", value: financialYearStartingMonth, label: L('Financial year starting month'), onChange: handleChange, options: monthOptions, invalidString: isError && error ? (error.message ? error.message : L('Something went wrong.')) : '' }))),
        React.createElement(ModalFooter, { loading: isLoading, done: done })));
};
export default YearsSetupModal;
